import React, { useEffect, useState } from 'react';
// Import addDoc, query, where, getDocs for bulk add
import { collection, getDocs, updateDoc, deleteDoc, doc, addDoc, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import './ManajemenPengguna.css'; // Import the CSS file

const ManajemenPengguna = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [editingRole, setEditingRole] = useState({}); // { userId: newRole }
  const [bulkAddStatus, setBulkAddStatus] = useState(''); // State for bulk add feedback

  // Data to be added
  const usersToAdd = [
    { nim: '122500001', nama: 'Meysita Putri', email: 'meysita.putri@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500002', nama: 'Tifani Pardede', email: 'tifani.pardede@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500004', nama: 'Tria Dara Syalsabina', email: 'tria.syalsabina@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500006', nama: 'Natasya Armelia Putri', email: 'natasya.putri@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500007', nama: 'Fhora Putri Lestari', email: 'fhora.lestari@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500008', nama: 'Puti Anisa Nur Fitriana', email: 'puti.fitriana@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500009', nama: 'Dina Putri Agustina', email: 'dina.agustina@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500010', nama: 'Shefia Dhiya Khansa', email: 'shefia.khansa@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500011', nama: 'Ayesha Dinda Akmeltha', email: 'ayesha.akmeltha@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500012', nama: 'Rahma Yenita Putri', email: 'rahma.putri@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500013', nama: 'Made Helen Susanti', email: 'made.susanti@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500014', nama: 'Sabili Rachma Dinni', email: 'sabili.dinni@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500015', nama: 'Petrus Alvin Peter Ambarita', email: 'petrus.ambarita@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500016', nama: 'Indri Azzahra', email: 'indri.azzahra@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500017', nama: 'Herlita Rahma Rostiana', email: 'herlita.rostiana@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500018', nama: 'Silvia salsabila', email: 'silvia.salsabila@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500019', nama: 'Sinta Bella Triyanti', email: 'sinta.triyanti@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500020', nama: 'Rika Oktavia', email: 'rika.oktavia@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500022', nama: 'Shinta Eryamana Putri', email: 'shinta.putri@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500024', nama: 'Devika Damayanti Silalahi', email: 'devika.silalahi@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500025', nama: 'Annisa Rahma Aryanti', email: 'annisa.aryanti@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500026', nama: 'Bagus Satria', email: 'bagus.satria@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500027', nama: 'Tia Azzahra Putri', email: 'tia.putri@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500028', nama: 'FELLA ANINDYA RANI', email: 'fella.rani@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500029', nama: 'Diajeng Lintang Husnul Khotimah', email: 'diajeng.khotimah@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500031', nama: 'Agitha Casanova Capah', email: 'agitha.capah@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500032', nama: 'Siwi Nurbaiti', email: 'siwi.nurbaiti@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500033', nama: 'Veni Putri Nurhayati', email: 'veni.nurhayati@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500034', nama: 'Wafiq Azizah Muhtar', email: 'wafiq.muhtar@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500036', nama: 'Adelia Oktaviana', email: 'adelia.oktaviana@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500037', nama: 'Chika Ari Dinar Rorensya', email: 'chika.rorensya@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500038', nama: 'RIFKA GULTOM', email: 'rifka.gultom@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' },
    { nim: '122500039', nama: 'Aida Febina Sholeha', email: 'aida.sholeha@student.itera.ac.id', programStudi: 'Rekayasa Kosmetik' }
  ];


  // Fetch users
  const fetchUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const querySnapshot = await getDocs(collection(db, 'users'));
      const usersData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setUsers(usersData);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError('Gagal mengambil data pengguna.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Handle role selection change
  const handleRoleChange = (userId, newRole) => {
    setEditingRole(prev => ({ ...prev, [userId]: newRole }));
  };

  // Save role change to Firestore
  const saveRoleChange = async (userId) => {
    const newRole = editingRole[userId];
    if (!newRole) return; // No change selected

    setLoading(true);
    setError('');
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, { role: newRole });
      // Update local state to reflect change immediately
      setUsers(prevUsers =>
        prevUsers.map(user =>
          user.id === userId ? { ...user, role: newRole } : user
        )
      );
      // Clear editing state for this user
      setEditingRole(prev => {
        const newState = { ...prev };
        delete newState[userId];
        return newState;
      });
      console.log(`Role updated for user ${userId} to ${newRole}`);
    } catch (err) {
      console.error("Error updating role:", err);
      setError(`Gagal memperbarui peran untuk pengguna ${userId}.`);
    } finally {
      setLoading(false);
    }
  };

  // Bulk Add Users Function
  const handleBulkAddUsers = async () => {
    setLoading(true);
    setError('');
    setBulkAddStatus('Menambahkan pengguna mahasiswa...');
    let addedCount = 0;
    let skippedCount = 0;
    let errorCount = 0;

    const usersCollection = collection(db, 'users');

    for (const user of usersToAdd) {
      try {
        // Check if user with the same email already exists
        const q = query(usersCollection, where("email", "==", user.email));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          // Add user if they don't exist
          await addDoc(usersCollection, {
            nama: user.nama,
            email: user.email,
            nim: user.nim,
            programStudi: user.programStudi,
            role: 'mahasiswa', // Set role to mahasiswa
            approved: true,    // Set approved status to true
            // Add other default fields if necessary, e.g., createdAt: serverTimestamp()
          });
          addedCount++;
        } else {
          // Skip if user already exists
          skippedCount++;
          console.log(`User with email ${user.email} already exists. Skipping.`);
        }
      } catch (err) {
        console.error(`Error adding user ${user.email}:`, err);
        setError(`Gagal menambahkan ${user.nama} (${user.email}).`);
        errorCount++;
        // Optionally break the loop on first error or continue
        // break;
      }
    }

    setLoading(false);
    setBulkAddStatus(`Selesai: ${addedCount} ditambahkan, ${skippedCount} dilewati, ${errorCount} gagal.`);
    if (addedCount > 0 || skippedCount > 0) {
        fetchUsers(); // Refresh list if anything changed or was skipped
    }
    // Clear status after a few seconds
    setTimeout(() => setBulkAddStatus(''), 5000);
  };


  // Delete user document from Firestore
  const handleDeleteUser = async (userId, userName) => {
    if (!window.confirm(`Hapus pengguna "${userName}" (${userId})? Tindakan ini hanya menghapus data pengguna dari database, bukan akun autentikasinya.`)) {
      return;
    }

    setLoading(true);
    setError('');
    try {
      await deleteDoc(doc(db, 'users', userId));
      // Remove user from local state
      setUsers(prevUsers => prevUsers.filter(user => user.id !== userId));
      console.log(`User document deleted for ${userId}`);
    } catch (err) {
      console.error("Error deleting user document:", err);
      setError(`Gagal menghapus data pengguna ${userId}.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="manajemen-pengguna-container">
      <h2>Manajemen Pengguna</h2>

      {error && <div className="error-message">{error}</div>}
      {bulkAddStatus && <div className="info-message">{bulkAddStatus}</div>} {/* Bulk Add Status */}
      {/* Adjust loading message visibility */}
      {loading && !bulkAddStatus && <div className="loading-message">Memuat data...</div>}


      <div className="pengguna-table-container">
        <table className="pengguna-table">
          <thead>
            <tr>
              <th>Nama</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.id}>
                <td>{user.nama || 'N/A'}</td>
                <td>{user.email || 'N/A'}</td>
                <td>{user.role}</td>
                <td>
                  <span className={`status-badge ${user.approved ? 'status-approved' : 'status-pending'}`}>
                    {user.approved ? 'Disetujui' : 'Pending'}
                  </span>
                </td>
                <td className="action-buttons">
                  <select
                    className="role-select"
                    value={editingRole[user.id] || user.role} // Show staged change or current role
                    onChange={(e) => handleRoleChange(user.id, e.target.value)}
                    disabled={loading}
                  >
                    <option value="mahasiswa">Mahasiswa</option>
                    <option value="laboran">Laboran</option>
                    <option value="admin">Admin</option>
                  </select>
                  {editingRole[user.id] && editingRole[user.id] !== user.role && (
                     <button
                       onClick={() => saveRoleChange(user.id)}
                       className="btn btn-save-role"
                       disabled={loading}
                     >
                       Simpan Role
                     </button>
                  )}
                  <button
                    onClick={() => handleDeleteUser(user.id, user.nama || user.email)}
                    className="btn btn-delete"
                    disabled={loading}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))}
            {users.length === 0 && !loading && (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center' }}>Belum ada data pengguna.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManajemenPengguna;
